module.exports = __webpack_public_path__ + "img/servicelist-02.bcb51486.png";